import { resolveDeviceOnline } from '../../utils';

/**
 * Screens-page filters. The backend list (/groups/company) has NO status filter -- it dropped it in 87ff3a2f (2025-03-26) -- so every
 * chip filters HERE, client-side, over the groups it already sent. Filtering only removes screens: the ones left keep the order the
 * backend sent (the customer's saved order), and clearing the filter brings the full ordered list straight back.
 *
 * "Online" is resolved the same way each card and the header counts resolve it (resolveDeviceOnline: backend connectivity.state).
 */
export const isScreenOnline = (d) => resolveDeviceOnline(d?.connectivity, d?.online);

/** keep only the screens `keep(d)` accepts; a group left with none is dropped. Order is never touched. */
export const filterGroupItems = (groups, keep) => Object.fromEntries(
    Object.entries(groups || {})
        .map(([k, g]) => [k, { ...g, items: (g.items || []).filter(keep) }])
        .filter(([, g]) => g.items.length)
);

/** isOnline: 1 = online chip, 0 = offline chip, null/undefined = all */
export const filterGroupsByStatus = (groups, isOnline) => (
    isOnline === null || isOnline === undefined
        ? groups
        : filterGroupItems(groups, (d) => isScreenOnline(d) === (Number(isOnline) === 1))
);
